import { Logger, LogLevels, Airbrake, Datadog } from '@calendly/logging-service'

import Experiments from 'services/experiments'
import FeatureFlags from 'services/feature_flags'

export default (data, appSettings) => {
  FeatureFlags.set(data.feature_flags)
  Experiments.set(data.modules.experiments)

  // This is strange, but some f/e test fail if we don't do this
  let options = { ...appSettings }
  if (options.datadog_js) {
    options = {
      ...options,
      datadog_js: {
        ...options.datadog_js,
      },
    }
  }

  return Logger.initialize({
    config: {
      environment: window.APP_ENV,
      version: window.APP_VERSION,
      logLevel: LogLevels.debug,
    },
    options,
    transports: [console, Airbrake, Datadog]
  })
}
